module.exports = __webpack_public_path__ + "assets/images/electoral-college/icons/winner-takes-all.svg?v=ec6f8cc1";